/**
 * Frontend fallback slug normalization - mirrors BE implementation
 *
 * ⚠️ This is a FALLBACK only used when BE endpoint is unavailable.
 * For production slug generation, always use:
 *   - ProductSlug.buildBaseSlug() [BE]
 * Source: /builds/one/backend/product-catalog/catalog-model/src/main/java/pl/unity/one/catalog/kernel/SlugNormalizer.kt
 *
 * Algorithm (must match BE exactly):
 * 1. Remove accents/diacritics (Ą→A, é→e)
 * 2. Convert to lowercase
 * 3. Replace &amp; → -
 * 4. Replace & → -
 * 5. Replace all invalid characters [^a-z0-9_-]+ with -
 * 6. Trim whitespace AND hyphens from edges
 *
 * Example: "Komputer&Mysz" → "komputer-mysz"
 * Example: "A/B Testing" → "a-b-testing"
 * Example: "Złoty Pierścionek" → "zloty-pierscionek"
 */
export default function useProductSlugify() {
  const normalizeSlug = (input: string): string => {
    const normalized = input
      .normalize('NFD')                           // Decompose diacritical marks
      .replace(/[\u0300-\u036f]/g, '')            // Remove accents
      .toLowerCase()                              // Convert to lowercase
      .replace(/&amp;/g, '-')                     // HTML entity &amp; → -
      .replace(/&/g, '-')                         // Replace & → -
      .replace(/[^a-z0-9_-]+/g, '-')              // Replace special characters → -
      .trim()                                     // Trim leading/trailing whitespace
      .replace(/^-+|-+$/g, '')                    // Trim leading/trailing hyphens

    if (!normalized) {
      throw new Error('No valid characters')
    }

    return normalized
  }

  return { normalizeSlug }
}
